// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxListWithLabel from '../../../shared/components/checkbox-list-with-label';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import {FormattedMessage} from 'react-intl';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';

const PinsNotRegisteredDealerCriteria = props => {

    const dealerSelectionMessage = props.selectedDealers.length ? 'DESELECT_ALL' : 'SELECT_ALL';

    return (
        <section className='pins-not-registered-dealer-criteria'>
            <CheckboxListWithLabel
                className='pins-not-registered-dealers'
                initialState={createHashMap(props.selectedDealers, 'account')}
                isRequired={true}
                label='DEALER_LOCATION'
                list={addCollectionLabels(props.selectedAccounts)}
                onChange={props.onDealerSelect}
                uid='account'
            />
            <button
                className='toggle-all'
                onClick={props.onSelectAllDealers}
                type='button'
            >
                <FormattedMessage id={dealerSelectionMessage}/>
            </button>
        </section>
    );

};

PinsNotRegisteredDealerCriteria.displayName = 'PinsNotRegisteredDealerCriteria';
PinsNotRegisteredDealerCriteria.propTypes = {
    onDealerSelect: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired
};

export default PinsNotRegisteredDealerCriteria;




// WEBPACK FOOTER //
// ./src/reports/pins-not-registered/components/pins-not-registered-dealer-criteria.js